/* Dermalaine prelaunch v0.2 PROTOTYPE. One reveal, nothing else animated.
   1. Adds .is-open to [data-dm-reveal] once it is 35% in view. Without JS, or with
      prefers-reduced-motion, the CSS shows the open state with no motion.
   2. Keeps the in-between timeline ([data-dm-stops]) in the tab order only while it actually
      scrolls sideways, so keyboard users can scroll it on phones/tablets and desktop gets no
      empty tab stop. No dependencies. */
(function () {
  var stops = document.querySelectorAll('[data-dm-stops]');
  if (stops.length) {
    var syncStops = function () {
      Array.prototype.forEach.call(stops, function (el) {
        if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('tabindex', '0');
        else el.removeAttribute('tabindex');
      });
    };
    syncStops();
    window.addEventListener('resize', syncStops);
  }

  var els = document.querySelectorAll('[data-dm-reveal]');
  if (!els.length) return;
  document.documentElement.classList.add('dm-pre-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('is-open'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-open'); io.unobserve(e.target); }
    });
  }, { threshold: 0.35 });
  Array.prototype.forEach.call(els, function (el) { io.observe(el); });
})();
